import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useCallback, useMemo, useState } from 'react';
import { Dropdown } from '../dropdown/dropdown';
import { context } from './utils';
import Button from './button';
import SimpleButton from './button.simple';
import Content from './content';
import Info from './info';
import Option from './option';
import OptionEmpty from './option-empty';
import Section from './section';
import Group from './group';
import Search from './search';
export var Select = function Select(_ref) {
  var children = _ref.children,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'single' : _ref$mode,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$native = _ref.native,
    native = _ref$native === void 0 ? false : _ref$native,
    dataTest = _ref.dataTest,
    _ref$onToggle = _ref.onToggle,
    onToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    info = _useState2[0],
    setInfo = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    nativeValue = _useState6[0],
    setNativeValue = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    list = _useState8[0],
    registerList = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    select = _useState10[0],
    registerSelect = _useState10[1];
  var showInfo = useCallback(function (show) {
    return setInfo(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        show: show
      });
    });
  }, []);
  var showSearch = useCallback(function (show) {
    return setSearch(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        show: show
      });
    });
  }, []);
  var registerInfoControl = useCallback(function (control) {
    return setInfo(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        control: control
      });
    });
  }, []);
  var registerSearchInput = useCallback(function (control) {
    return setSearch(function (prev) {
      return Object.assign(Object.assign({}, prev), {
        control: control
      });
    });
  }, []);
  var contextValue = useMemo(function () {
    return {
      list: list,
      select: select,
      info: info,
      mode: mode,
      native: native,
      nativeValue: nativeValue,
      onChange: onChange,
      registerInfoControl: registerInfoControl,
      registerList: registerList,
      registerSearchInput: registerSearchInput,
      registerSelect: registerSelect,
      search: search,
      setNativeValue: setNativeValue,
      showInfo: showInfo,
      showSearch: showSearch,
      dataTest: dataTest
    };
  }, [list, select, info, mode, native, nativeValue, onChange, registerInfoControl, registerList, registerSearchInput, registerSelect, search, setNativeValue, showInfo, showSearch, dataTest]);
  if (native) {
    return React.createElement(SelectProvider, {
      value: contextValue
    }, children);
  }
  return React.createElement(Dropdown, {
    onToggle: onToggle
  }, React.createElement(SelectProvider, {
    value: contextValue
  }, children));
};
function SelectProvider(_ref2) {
  var value = _ref2.value,
    children = _ref2.children;
  return React.createElement(context.Provider, {
    value: value
  }, children);
}
Select.Button = Button;
Select.SimpleButton = SimpleButton;
Select.Content = Content;
Select.Info = Info;
Select.Option = Option;
Select.OptionEmpty = OptionEmpty;
Select.Section = Section;
Select.Group = Group;
Select.Search = Search;